// state
export const state = {
    show: false,
}

// getters
export const getters = {
    getshow: state => state.show,
}

// mutations
export const mutations = {
    setshow(state, payload) {
        state.show = payload
    }	
}

// actions
export const actions = {
    changeSpinner({context}, payload) {
        context.commit('setshow', payload)
    }
}



// WEBPACK FOOTER //
// ./src/store/modules/misc.js